<div class="row nova-font-style adjustment-grid">
  <div class="col s12 m12 l12 xl12 remove-default-padding">
    <h2>Enrollments</h2>
    <div>
      <div [hidden]="initialLoading">
        <kendo-tabstrip #enrolltabstrip [animate]="true" [tabAlignment]="'justify'" (tabSelect)="onSelect($event)">
          <kendo-tabstrip-tab title="Enroll Member" [selected]="(adminOperators && adminOperators.View) ? false : true"
            [disabled]="adminOperators?.View">
            <ng-template kendoTabContent>
              <app-enroll-member (formDirtyOrTouched)="disableHistory($event)" [enrollmentDataItem]="editEnrollmentData"></app-enroll-member>
            </ng-template>
          </kendo-tabstrip-tab>
          <kendo-tabstrip-tab title="In-Progress/Pending" [selected]="(adminOperators && adminOperators.View) ? true : false"
            [disabled]="isHistoryDisable">
            <ng-template kendoTabContent>
              <app-pending-enrollments (loadPendingEnrollment)="getEnrollmentRecord($event)"></app-pending-enrollments>
            </ng-template>
          </kendo-tabstrip-tab>
          <kendo-tabstrip-tab title="Processed" [selected]="(adminOperators && adminOperators.View) ? true : false"
            [disabled]="isHistoryDisable">
            <ng-template kendoTabContent>
              <app-processed-enrollments></app-processed-enrollments>
            </ng-template>
          </kendo-tabstrip-tab>
        </kendo-tabstrip>
      </div>
    </div>
  </div>
</div>
